<template>
  <div class="categorias-page">
    <div class="bg-grid" aria-hidden="true"></div>

    <div class="categorias-shell">
      <!-- Header -->
      <header class="page-header fade-in">
        <div class="page-icon-box">
          <v-icon color="#F2F2ED" size="20">mdi-shape</v-icon>
        </div>
        <div>
          <h1 class="page-title">Categorías de ejercicios</h1>
          <p class="page-sub">Organiza tu biblioteca por tipo de ejercicio</p>
        </div>
      </header>

      <!-- Tabla -->
      <section class="fade-in delay-100">
        <div class="card-flat card-flat-nopad">
          <div class="table-head">
            <span class="section-eyebrow">
              <span class="tick-mark"></span>
              Listado de categorías
            </span>
          </div>

          <v-progress-linear :active="cargando" :indeterminate="cargando" absolute top
            color="#C8FF4D"></v-progress-linear>

          <v-data-table :headers="encabezadoTabla" :items="categorias" sort-by="nombre"
            no-data-text="No hay categorías registradas" class="dash-table"
            :footer-props="{ itemsPerPageText: 'Por página' }">
            <template v-slot:[`item.icono`]="{ item }">
              <div class="icon-box">
                <v-icon size="16" color="#C8FF4D">{{ item.icono || 'mdi-dumbbell' }}</v-icon>
              </div>
            </template>

            <template v-slot:[`item.nombre`]="{ item }">
              <span class="cell-strong">{{ item.nombre }}</span>
            </template>

            <template v-slot:[`item.descripcion`]="{ item }">
              <span v-if="item.descripcion" class="cell-secondary">{{ item.descripcion }}</span>
              <span v-else class="cell-muted">Sin descripción</span>
            </template>

            <template v-slot:[`item.opciones`]="{ item }">
              <div class="flex gap-xs">
                <button class="icon-btn" @click="editar(item)" title="Editar">
                  <v-icon size="15" color="#8C8C93">mdi-pencil</v-icon>
                </button>
                <button class="icon-btn icon-btn-danger" @click="eliminar(item)" title="Eliminar">
                  <v-icon size="15" color="#FF6B6B">mdi-delete</v-icon>
                </button>
              </div>
            </template>

            <template v-slot:no-data>
              <div class="empty-state">
                <div class="empty-icon">
                  <v-icon size="28" color="#5C5C62">mdi-shape-outline</v-icon>
                </div>
                <h3 class="empty-title">No hay categorías registradas</h3>
                <p class="empty-desc">Comienza agregando una categoría para organizar tus ejercicios</p>
                <button class="btn-primary mt-lg" @click="mostrarDialogo = true">
                  <v-icon size="15" class="mr-2">mdi-plus</v-icon>
                  Agregar categoría
                </button>
              </div>
            </template>
          </v-data-table>
        </div>
      </section>
    </div>

    <!-- FAB -->
    <button class="fab-button" @click="mostrarDialogo = true">
      <v-icon size="22" color="#0E0E10">mdi-plus</v-icon>
    </button>

    <!-- Diálogo: Formulario -->
    <v-dialog v-model="mostrarDialogo" persistent max-width="600px">
      <form-categoria-ejercicio @cerrado="onCerrado" @registrar="onRegistrar" :categoria="categoria"
        :titulo="titulo" />
    </v-dialog>

    <!-- Diálogo: Eliminar -->
    <v-dialog v-model="mostrarDialogoEliminar" max-width="500px">
      <dialogo-eliminar :nombre="itemSeleccionado" @cancelar="cerrarDialogoEliminar"
        @eliminar="confirmarEliminar" />
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar v-model="mostrarMensaje" :timeout="3000" :color="mensaje.color" top right>
      <div class="flex items-center gap-md">
        <v-icon color="white">{{ mensajeIcon }}</v-icon>
        <span>{{ mensaje.texto }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn icon small @click="mostrarMensaje = false" v-bind="attrs">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import FormCategoriaEjercicio from './FormCategoriaEjercicio.vue'
import DialogoEliminar from '../Dialogos/DialogoEliminar.vue'
import HttpService from '../../Servicios/HttpService'

export default {
  name: "CategoriasEjercicios",
  components: {
    FormCategoriaEjercicio,
    DialogoEliminar
  },

  data: () => ({
    cargando: false,
    mostrarDialogo: false,
    mostrarDialogoEliminar: false,
    categoria: {
      nombre: "",
      descripcion: "",
      icono: "mdi-dumbbell"
    },
    categorias: [],
    mensaje: {
      texto: "",
      color: ""
    },
    mostrarMensaje: false,
    encabezadoTabla: [
      { text: "Icono", value: "icono", sortable: false },
      { text: "Nombre", value: "nombre", sortable: true },
      { text: "Descripción", value: "descripcion" },
      { text: 'Opciones', value: 'opciones', sortable: false },
    ],
    titulo: "Agregar",
    itemSeleccionado: ""
  }),

  computed: {
    mensajeIcon() {
      switch (this.mensaje.color) {
        case 'success': return 'mdi-check-circle';
        case 'error': return 'mdi-alert-circle';
        case 'warning': return 'mdi-alert';
        default: return 'mdi-information';
      }
    }
  },

  mounted() {
    this.obtenerCategorias();
  },

  methods: {
    editar(categoria) {
      this.titulo = "Editar";
      this.categoria = { ...categoria };
      this.mostrarDialogo = true;
    },

    eliminar(categoria) {
      this.itemSeleccionado = categoria.nombre;
      this.categoria = { ...categoria };
      this.mostrarDialogoEliminar = true;
    },

    cerrarDialogoEliminar() {
      this.mostrarDialogoEliminar = false;
      this.categoria = {
        nombre: "",
        descripcion: "",
        icono: "mdi-dumbbell"
      };
    },

    confirmarEliminar() {
      this.cargando = true;
      let payload = {
        metodo: "delete",
        id: this.categoria.id
      };

      HttpService.eliminar("categorias_ejercicios.php", payload)
        .then(eliminado => {
          if (eliminado) {
            this.mostrarDialogoEliminar = false;
            this.mostrarMensaje = true;
            this.mensaje.texto = "Categoría eliminada";
            this.mensaje.color = "success";
            this.cargando = false;
            this.obtenerCategorias();
          }
        })
        .catch(error => {
          this.cargando = false;
          this.mostrarMensaje = true;
          this.mensaje.texto = "Error al eliminar la categoría";
          this.mensaje.color = "error";
          console.error("Error al eliminar:", error);
        });
    },

    onCerrado(valor) {
      this.categoria = {
        nombre: "",
        descripcion: "",
        icono: "mdi-dumbbell"
      };
      this.mostrarDialogo = valor;
      this.titulo = "Agregar";
    },

    onRegistrar(categoria) {
      let metodo = (this.titulo === "Agregar") ? "post" : "put";
      this.categoria = categoria;
      this.cargando = true;

      let payload = {
        metodo: metodo,
        categoria: this.categoria
      };

      HttpService.registrar(payload, "categorias_ejercicios.php")
        .then(respuesta => {
          if (respuesta) {
            this.categoria = {
              nombre: "",
              descripcion: "",
              icono: "mdi-dumbbell"
            };
            this.mostrarDialogo = false;
            this.mostrarMensaje = true;
            this.mensaje.texto = "Categoría registrada";
            this.mensaje.color = "success";
            this.cargando = false;
            this.obtenerCategorias();
            this.titulo = "Agregar";
          }
        })
        .catch(error => {
          this.cargando = false;
          this.mostrarMensaje = true;
          this.mensaje.texto = "Error al registrar la categoría";
          this.mensaje.color = "error";
          console.error("Error al registrar:", error);
        });
    },

    obtenerCategorias() {
      this.cargando = true;
      let payload = { metodo: "get" };

      HttpService.obtenerConDatos(payload, "categorias_ejercicios.php")
        .then(respuesta => {
          this.categorias = respuesta;
          this.cargando = false;
        })
        .catch(error => {
          this.cargando = false;
          this.mostrarMensaje = true;
          this.mensaje.texto = "Error al cargar las categorías";
          this.mensaje.color = "error";
          console.error("Error al obtener categorías:", error);
        });
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;700&family=Inter:wght@400;500;600&family=JetBrains+Mono:wght@500&display=swap');

/* ===== TOKENS ===== */
.categorias-page {
  --bg: #0E0E10;
  --card: #17171A;
  --card-border: #26262A;
  --text-primary: #F2F2ED;
  --text-secondary: #8C8C93;
  --text-tertiary: #5C5C62;
  --accent: #C8FF4D;
  --accent-dim: rgba(200, 255, 77, 0.12);
  --error: #FF6B6B;
  --radius: 4px;

  --font-display: 'Space Grotesk', sans-serif;
  --font-body: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  --font-mono: 'JetBrains Mono', monospace;
}

.categorias-page {
  min-height: 100vh;
  background: var(--bg);
  color: var(--text-primary);
  font-family: var(--font-body);
  position: relative;
  padding: 40px;
}

.bg-grid {
  position: fixed;
  inset: 0;
  background-image:
    linear-gradient(rgba(242, 242, 237, 0.02) 1px, transparent 1px),
    linear-gradient(90deg, rgba(242, 242, 237, 0.02) 1px, transparent 1px);
  background-size: 48px 48px;
  pointer-events: none;
  z-index: 0;
}

.categorias-shell {
  position: relative;
  z-index: 1;
  max-width: 1000px;
  margin: 0 auto;
}

/* ===== HEADER ===== */
.page-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 22px 26px;
  background: var(--card);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  margin-bottom: 20px;
}

.page-icon-box {
  width: 42px;
  height: 42px;
  border-radius: var(--radius);
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid var(--card-border);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.page-title {
  font-family: var(--font-display);
  font-size: 19px;
  font-weight: 700;
  margin: 0 0 2px;
}

.page-sub {
  font-size: 13px;
  color: var(--text-secondary);
  margin: 0;
}

/* ===== CARD / TABLA ===== */
.card-flat {
  background: var(--card);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
}

.card-flat-nopad {
  overflow: hidden;
  position: relative;
}

.table-head {
  padding: 18px 22px;
  border-bottom: 1px solid var(--card-border);
}

.section-eyebrow {
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: var(--font-mono);
  font-size: 11px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--text-secondary);
}

.tick-mark {
  width: 12px;
  height: 1px;
  background: var(--accent);
}

.icon-box {
  width: 30px;
  height: 30px;
  border-radius: var(--radius);
  background: var(--accent-dim);
  border: 1px solid var(--card-border);
  display: flex;
  align-items: center;
  justify-content: center;
}

.cell-strong {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
}

.cell-secondary {
  font-size: 12.5px;
  color: var(--text-secondary);
}

.cell-muted {
  font-size: 12.5px;
  color: var(--text-tertiary);
}

.icon-btn {
  width: 28px;
  height: 28px;
  border-radius: var(--radius);
  background: transparent;
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.icon-btn:hover {
  border-color: var(--card-border);
  background: rgba(255, 255, 255, 0.03);
}

.icon-btn-danger:hover {
  border-color: rgba(255, 107, 107, 0.3);
  background: rgba(255, 107, 107, 0.06);
}

/* ===== EMPTY STATE ===== */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 56px 20px;
}

.empty-icon {
  width: 56px;
  height: 56px;
  border-radius: var(--radius);
  border: 1px solid var(--card-border);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.empty-title {
  font-family: var(--font-display);
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 6px;
}

.empty-desc {
  font-size: 13px;
  color: var(--text-secondary);
  margin: 0 0 4px;
  max-width: 340px;
}

/* ===== FAB ===== */
.fab-button {
  position: fixed;
  bottom: 32px;
  right: 32px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--accent);
  border: none;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  cursor: pointer;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.15s ease, filter 0.15s ease;
}

.fab-button:hover {
  transform: scale(1.06);
  filter: brightness(1.05);
}

/* ===== BUTTONS ===== */
.btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--accent);
  color: var(--bg);
  border: none;
  border-radius: var(--radius);
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: filter 0.15s ease;
}

.btn-primary:hover {
  filter: brightness(1.08);
}

/* ===== MOTION ===== */
.fade-in {
  animation: fadeIn 0.4s ease both;
}

.delay-100 { animation-delay: 0.05s; }

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@media (prefers-reduced-motion: reduce) {
  .fade-in { animation: none; }
}

/* ===== Overrides v-data-table ===== */
.dash-table {
  background: transparent !important;
}

.dash-table >>> .v-data-table__wrapper {
  background: transparent;
}

.dash-table >>> table {
  background: transparent;
}

.dash-table >>> thead th {
  background: rgba(255, 255, 255, 0.02) !important;
  color: var(--text-tertiary) !important;
  text-transform: uppercase;
  font-size: 10px !important;
  letter-spacing: 0.08em;
  font-family: var(--font-mono);
  border-bottom: 1px solid var(--card-border) !important;
  padding: 0 22px !important;
}

.dash-table >>> tbody td {
  border-bottom: 1px solid var(--card-border) !important;
  padding: 10px 22px !important;
}

.dash-table >>> tbody tr:hover {
  background: rgba(255, 255, 255, 0.02) !important;
}

.dash-table >>> .v-data-footer {
  color: var(--text-tertiary) !important;
  border-top: 1px solid var(--card-border) !important;
  font-size: 12px;
  padding: 0 22px;
}

.dash-table >>> .v-data-footer__select .v-select__selection {
  color: var(--text-secondary) !important;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 768px) {
  .categorias-page {
    padding: 20px;
  }

  .page-header {
    padding: 18px;
  }

  .dash-table >>> thead th,
  .dash-table >>> tbody td {
    padding: 10px 14px !important;
    font-size: 12px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Planes/CategoriasEjercicios.vue